import React from 'react'
import { SvgIcon, type SvgIconProps } from "@mui/material"

function CheckboxUncheckedIcon1(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="2" width="20" height="20" stroke="black" strokeOpacity="0.2" strokeWidth="2" />
      </svg>
    </SvgIcon>
  )
}

export default CheckboxUncheckedIcon1